import { from, switchMap } from 'rxjs';
import { AdminAuthService } from './admin-auth.service';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

export const adminAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AdminAuthService);
  return from(authService.getIdToken()).pipe(
    switchMap(token => {
      if (!token) return next(req); // don't attach "Bearer null"
      return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
    }),
  );
};
